import { render, staticRenderFns } from "./CreateProcessStatusRule.vue?vue&type=template&id=633b17f2"
import script from "./CreateProcessStatusRule.vue?vue&type=script&lang=js"
export * from "./CreateProcessStatusRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports